import { VariantProps, cva } from "class-variance-authority";
import { useMemo } from "react";

import { UserResponseEntity } from "@/src/hooks/api/generated";

import SpeakerCard from "../../app/[locale]/(public-with-specific-layout)/workpride/components/SpeakerCard";
import { Slider } from "../slider/Slider";

interface IMembersSliderProps extends VariantProps<typeof sectionClasses> {
  type: string;
  users: UserResponseEntity[];
  slidesToShow?: number;
}

export function MembersSlider({
  type = "hosts",
  users,
  slidesToShow = 4,
}: IMembersSliderProps): JSX.Element {
  const settings = {
    dots: false,
    infinite: users.length > 1,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: slidesToShow > 1 ? 2 : slidesToShow,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const renderItems = useMemo(
    () =>
      users.map((member) => (
        <div
          className={`${
            type === "speakers"
              ? "mx-auto lg:mx-0"
              : "max-w-6xl sm:w-1/2 md:w-1/3 lg:w-1/4 !gap-4"
          }`}
          key={member.id}
        >
          <SpeakerCard type={type} speaker={member} />
        </div>
      )),
    [users]
  );

  if (type === "speakers") {
    return <div className="flex flex-wrap gap-4">{renderItems}</div>;
  }

  return <Slider settings={settings}>{renderItems}</Slider>;
}

const sectionClasses = cva("flex flex-col w-full", {
  variants: {
    spacing: {
      large: "gap-y-5 lg:gap-y-10",
      small: "gap-y-5",
    },
  },

  defaultVariants: {
    spacing: "large",
  },
});
